import { toast } from 'react-toastify'
import { useSearchParams } from 'react-router-dom'
import Select, { } from 'react-select'
import makeAnimated from 'react-select/animated';
import { useState, useEffect } from 'react';
import useGetHook from '../../customHooks/useGetHook'
import APIS from '../../constant/EndPoint'
const animatedComponents = makeAnimated();

export default function RiderActionMenu(props: any) {
  const [searchParams, setSearchParms] = useSearchParams()
  const { setValue, watch } = props
  const [defaultValue, setDefaultValue] = useState()

  const { data: statusList, } = useGetHook({
    queryKey: [`status`],
    url: `${APIS.STATUS}`,
    params: {
      is_rider_status: true
    },
  });

  const handleButtonClick = (type: string) => {
    const selectedOrder = searchParams.get("selectedItems")?.split(",")
    if (!selectedOrder?.length) {
      toast.error("Please select at least one order first")
      return
    }
    props?.setOrderActionMenu(true)
    props?.setActionType(type)
  }
  const onChange = (value: any) => {
    setValue("delivery_status__in", value)
    setDefaultValue(value)
  };

  useEffect(() => {
    if (!defaultValue) {
      setDefaultValue(watch("delivery_status__in"))
    }
  }, [watch("status")])
  return (
    <>
      <div className='w-full md:flex md:justify-between md:gap-x-4'>
        <div className='w-full'>
          <Select
            value={defaultValue}
            components={animatedComponents}
            closeMenuOnSelect={false}
            options={statusList}
            onChange={onChange}
            isMulti
          />
        </div>
        <button
          className="p-1 w-full md:w-[200px] gap-x-2 my-3 md:my-0 rounded text-primary border"
          onClick={() => handleButtonClick("Change Status")}
        >
          Action
        </button>

      </div>

    </>

  )
}
